import { EVENTS_CONSTANTS } from "config/constants";
import { requestFinalizeEventDraft } from "services/events/aboutEvents";
import { eventsSessionStorage } from "services/storage/events";
import useMainContext from "utils/context/useMainContext";
import useCheckNonExpiredDuration from "./useCheckNonExpiredDuration";

const { FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE } = EVENTS_CONSTANTS;
const useFinalizeEvent = ({
	loadingRequest,
	form, nextStep,
	toggleShowDialogCreatedEvent,
}) => {
	const { setShowDialogUnexpectedError, setDialogUnexpectedErrorMessage } =
		useMainContext();
	function success() {
		eventsSessionStorage.eventId.remove();
		window.scroll({ top: 0, behavior: "smooth" });
		nextStep();
		toggleShowDialogCreatedEvent();
	}
	function error(message) {
		const errorText = FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[message];
		if (errorText) setDialogUnexpectedErrorMessage(errorText);
		setShowDialogUnexpectedError(true);
	}
	const checkNonExpiredDuration = useCheckNonExpiredDuration({
		form
	});
	const finalizeEvent = async () => {
		if (!checkNonExpiredDuration()) 
			return;
		loadingRequest.show("Guardando tu evento creado...");
		const message = await requestFinalizeEventDraft(
			eventsSessionStorage.eventId.get()
		);
		loadingRequest.hide();
		if (message) error(message);
		else success();
	};
	return finalizeEvent;
};

export default useFinalizeEvent;
